import React from 'react';

import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import { Stack, Tooltip } from '@mui/material';

import CustomModal from './CustomModal';
import { useResponsive } from './ResponsiveProvider';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  title: string;
  children: React.ReactNode;
  onConfirm?: VoidFunction;
  headerOnClose?: VoidFunction;
  onConfirmSecondBtn?: VoidFunction;
  confirmBtnText?: string;
  confirmSecondBtnText?: string;
  cancelBtnText?: string;
  renderAction?: React.ReactNode;
  buttonLoading?: boolean;
  confirmButtonProps?: LoadingButtonProps;
  confirmSecondButtonProps?: LoadingButtonProps;
  disabledConfirmBtn?: boolean;
  variant?: string;
  confirmButtonTooltip?: string;
}

const ReusableConfirmationModal: React.FC<Props> = ({
  open,
  headerOnClose,
  onClose,
  onConfirm,
  onConfirmSecondBtn,
  title,
  confirmBtnText,
  confirmSecondBtnText,
  cancelBtnText,
  renderAction,
  children,
  buttonLoading = false,
  confirmButtonProps,
  confirmSecondButtonProps,
  disabledConfirmBtn = false,
  variant,
  confirmButtonTooltip,
}) => {
  const { isMobile } = useResponsive();

  return (
    <CustomModal
      title={title}
      open={open}
      handleClose={headerOnClose ? headerOnClose : onClose}
      variant={variant}
    >
      <Stack
        direction="column"
        spacing={2}
        margin={isMobile ? '15px 0' : '15px'}
      >
        {children}
        {renderAction ? (
          renderAction
        ) : (
          <Stack
            direction="row"
            spacing={isMobile ? 0 : 1}
            flexWrap={isMobile ? 'wrap' : 'nowrap'}
            gap={isMobile ? '6px' : 0}
          >
            <Tooltip title={confirmButtonTooltip ? confirmButtonTooltip : ''}>
              <span style={{ display: 'inline-flex' }}>
                <LoadingButton
                  disabled={disabledConfirmBtn}
                  loading={buttonLoading}
                  {...(onConfirm && {
                    onClick: onConfirm,
                  })}
                  variant="contained"
                  style={
                    isMobile
                      ? {
                          fontSize: '12px',
                          padding: '5px 15px',
                          width: 'fit-content',
                          height: 40,
                          margin: 0,
                        }
                      : { padding: '5px 15px', height: 40, margin: 0 }
                  }
                  {...confirmButtonProps}
                >
                  {confirmBtnText}
                </LoadingButton>
              </span>
            </Tooltip>
            {confirmSecondBtnText && (
              <LoadingButton
                loading={buttonLoading}
                onClick={onConfirmSecondBtn}
                variant="contained"
                style={
                  isMobile
                    ? { fontSize: '12px', padding: '5px 15px', height: 40 }
                    : { padding: '5px 15px', height: 40 }
                }
                {...confirmSecondButtonProps}
              >
                {confirmSecondBtnText}
              </LoadingButton>
            )}
            <LoadingButton
              loading={buttonLoading}
              onClick={onClose}
              variant="outlined"
              style={
                isMobile
                  ? {
                      fontSize: '12px',
                      padding: '5px 15px',
                      width: 'fit-content',
                      height: 40,
                    }
                  : { padding: '5px 15px', height: 40 }
              }
            >
              {cancelBtnText}
            </LoadingButton>
          </Stack>
        )}
      </Stack>
    </CustomModal>
  );
};

export default ReusableConfirmationModal;
